import type { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { getAuth } from 'firebase/auth';
import { catchError, from, switchMap } from 'rxjs';

export const fsAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url;

  const shouldAttachToken = url.startsWith(environment.baseUrlWeb);

  if (!shouldAttachToken) {
    return next(req); // No tocar otras APIs
  }

  return from(getFirebaseToken()).pipe(
    switchMap((token) => {
      if (!token) return next(req);

      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(cloned);
    }),
    catchError(() => {
      // Opcional: limpiar token o cerrar sesión
      return next(req);
    })
  );
};

function getFirebaseToken(): Promise<string | null> {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return Promise.resolve(null);

  return user.getIdToken().catch(() => null);
}
